export default __webpack_public_path__ + "static/media/vladimir.c3285673.ttf";